import React, { useState } from 'react';

interface TruncatedTextProps {
  text: string;  // The full text to be displayed
  maxLength?: number;  // Optional maxLength to truncate text
}

const TruncatedText: React.FC<TruncatedTextProps> = ({ text="", maxLength = 30 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  // Truncate the text if it's longer than maxLength
  const truncatedText = text?.length > maxLength ? text.slice(0, maxLength) + '...' : text;

  // Split the text into an array of items (by commas) when expanded
  const splitText = text?.split(',');

  return (
    <div style={{ fontWeight: 'normal' }}>
      {/* Display truncated text or full text */}
      {isExpanded ? (
        <div>
          {splitText?.map((item, index) => (
            <p key={index} style={{ fontWeight: 'normal', margin: 0 }}>
              {item.trim()}  {/* Display each comma-separated item in a <p> element */}
            </p>
          ))}
        </div>
      ) : (
        <span style={{ fontWeight: 'normal' }}>{truncatedText}</span>  
      )}

      {/* Show "show more" or "show less" link if the text is truncated */}
      {text?.length > maxLength && (
        <span
          style={{
            cursor: 'pointer',
            color: 'blue',
            fontWeight: 'normal',  // Enforce non-bold for the link
          }}
          onClick={handleToggle}
        >
          {isExpanded ? ' (less)' : '... (more)'}
        </span>
      )}
    </div>
  );
};

export default TruncatedText;
